<template>
  <div class="shift-period-view-table">
    <el-button
      v-if="isEditMode"
      type="primary"
      size="small"
      icon="el-icon-plus"
      @click="addPeriod"
    >
      添加
    </el-button>
    <el-table
      v-if="tableRows.length"
      :data="tableRows"
      border
      size="small"
      :style="{ width: '100%', marginTop: isEditMode ? '10px' : '0' }"
      :span-method="spanMethod"
    >
      <el-table-column :width="isEditMode ? 90 : 100" label=" " align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.rowType === 'in'">
            {{ "第" + (scope.row.periodIndex + 1) + "次" }}
          </div>
          <div>(工时:{{ calcWorkHours(scope.row.period) }}H)</div>
        </template>
      </el-table-column>
      <el-table-column :width="isEditMode ? 80 : 70" label="上下班" align="center">
        <template slot-scope="scope">
          {{ scope.row.rowType === "in" ? "上班" : "下班" }}
        </template>
      </el-table-column>
      <el-table-column :width="isEditMode ? 115 : 135" label="工作时间" align="center">
        <template slot-scope="scope">
          <template v-if="isEditMode">
            <el-time-picker
              v-model="scope.row.period[scope.row.rowType === 'in' ? 'clock_in' : 'clock_out']"
              format="HH:mm"
              value-format="HH:mm"
              :placeholder="scope.row.rowType === 'in' ? '开始时间' : '结束时间'"
              size="small"
              style="width: 100%;"
              append-to-body
              @change="emitChange"
            />
          </template>
          <template v-else>
            {{ (scope.row.rowType === "in" ? scope.row.period.clock_in : scope.row.period.clock_out) || "-" }}
          </template>
        </template>
      </el-table-column>
      <el-table-column label="中途休息时间" align="center" min-width="200">
        <template slot-scope="scope">
          <template v-if="scope.row.rowType === 'in'">
            <template v-if="isEditMode">
              <div class="break-time-pickers">
                <el-time-picker
                  v-model="scope.row.period.break_time[0]"
                  format="HH:mm"
                  value-format="HH:mm"
                  placeholder="开始"
                  clearable
                  size="small"
                  class="break-tp"
                  append-to-body
                  @change="emitChange"
                />
                <span class="break-sep">-</span>
                <el-time-picker
                  v-model="scope.row.period.break_time[1]"
                  format="HH:mm"
                  value-format="HH:mm"
                  placeholder="结束"
                  clearable
                  size="small"
                  class="break-tp"
                  append-to-body
                  @change="emitChange"
                />
              </div>
            </template>
            <template v-else>
              {{ formatBreakTime(scope.row.period.break_time) }}
            </template>
          </template>
        </template>
      </el-table-column>
      <el-table-column width="115" label="打卡开始时间" align="center">
        <template slot-scope="scope">
          <template v-if="isEditMode">
            <el-time-picker
              v-model="scope.row.period[scope.row.rowType === 'in' ? 'in_start' : 'out_start']"
              format="HH:mm"
              value-format="HH:mm"
              placeholder="选择时间"
              size="small"
              style="width: 100%;"
              append-to-body
              :picker-options="scope.row.rowType === 'in' ? getInStartPickerOptions(scope.row.period) : getOutStartPickerOptions(scope.row.period)"
              @change="emitChange"
            />
          </template>
          <template v-else>
            {{ scope.row.period.punch_start_time || (scope.row.rowType === "in" ? scope.row.period.in_start : scope.row.period.out_start) || "-" }}
          </template>
        </template>
      </el-table-column>
      <el-table-column label="打卡结束时间" align="center" width="115">
        <template slot-scope="scope">
          <template v-if="isEditMode">
            <el-time-picker
              v-model="scope.row.period[scope.row.rowType === 'in' ? 'in_end' : 'out_end']"
              format="HH:mm"
              value-format="HH:mm"
              placeholder="选择时间"
              size="small"
              style="width: 100%;"
              append-to-body
              :picker-options="scope.row.rowType === 'in' ? getInEndPickerOptions(scope.row.period) : getOutEndPickerOptions(scope.row.period)"
              @change="emitChange"
            />
          </template>
          <template v-else>
            {{ scope.row.period.punch_end_time || (scope.row.rowType === "in" ? scope.row.period.in_end : scope.row.period.out_end) || "-" }}
          </template>
        </template>
      </el-table-column>
      <el-table-column v-if="isEditMode" label="操作" align="center" width="64">
        <template slot-scope="scope">
          <template v-if="scope.row.rowType === 'in'">
            <el-button
              type="text"
              size="small"
              style="color: #F56C6C;"
              @click="removePeriod(scope.row.periodIndex)"
              :disabled="scope.row.periodIndex === 0"
            >
              删除
            </el-button>
          </template>
        </template>
      </el-table-column>
    </el-table>
    <span v-else class="empty-text">-</span>
  </div>
</template>

<script>
const EMPTY_PERIOD = () => ({
  in_date: "",
  out_date: "",
  clock_in: "",
  clock_out: "",
  break_time: ["", ""],
  in_start: "",
  in_end: "",
  out_start: "",
  out_end: "",
});

export default {
  name: "ShiftPeriodViewTable",
  props: {
    periods: {
      type: Array,
      default: () => [],
    },
    editable: {
      type: Boolean,
      default: false,
    },
    isView: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      innerPeriods: [],
    };
  },
  computed: {
    isEditMode() {
      return this.isView ? false : this.editable;
    },
    normalizedPeriods() {
      const periods = this.periods || [];
      if (!periods.length) return [];
      const first = periods[0] || {};
      if (
        Object.prototype.hasOwnProperty.call(first, "clock_in") ||
        Object.prototype.hasOwnProperty.call(first, "clock_out")
      ) {
        return periods;
      }
      return this.apiPeriodsToFormPeriods(periods);
    },
    currentPeriods() {
      return this.isEditMode ? this.innerPeriods : this.normalizedPeriods;
    },
    tableRows() {
      const rows = [];
      this.currentPeriods.forEach((period, index) => {
        rows.push({ periodIndex: index, rowType: "in", period });
        rows.push({ periodIndex: index, rowType: "out", period });
      });
      return rows;
    },
  },
  watch: {
    periods: {
      immediate: true,
      deep: true,
      handler(val) {
        if (!this.isEditMode) return;
        this.innerPeriods = this.clonePeriods(this.normalizeForEdit(val));
      },
    },
  },
  methods: {
    normalizeBreakSlot(bt) {
      if (Array.isArray(bt)) {
        return [(bt[0] != null && bt[0] !== "") ? String(bt[0]).trim() : "", (bt[1] != null && bt[1] !== "") ? String(bt[1]).trim() : ""];
      }
      if (typeof bt === "string" && bt && bt.includes("-")) {
        const parts = bt.split("-");
        return [(parts[0] || "").trim(), (parts[1] || "").trim()];
      }
      return ["", ""];
    },
    clonePeriods(periods) {
      return (periods || []).map((item) => ({
        ...EMPTY_PERIOD(),
        ...item,
        break_time: this.normalizeBreakSlot(item.break_time),
      }));
    },
    normalizeForEdit(periods) {
      const list = periods || [];
      if (!list.length) return [EMPTY_PERIOD()];
      const first = list[0] || {};
      if (
        Object.prototype.hasOwnProperty.call(first, "clock_in") ||
        Object.prototype.hasOwnProperty.call(first, "clock_out")
      ) {
        return list;
      }
      return this.apiPeriodsToFormPeriods(list);
    },
    apiPeriodsToFormPeriods(apiPeriods) {
      if (!apiPeriods || !apiPeriods.length) return [];
      const byRound = {};
      apiPeriods.forEach((p) => {
        const r = p.round_no != null ? p.round_no : 0;
        if (!byRound[r]) byRound[r] = {};
        if (p.clock_type === 1) byRound[r].in = p;
        else if (p.clock_type === 2) byRound[r].out = p;
      });
      return Object.keys(byRound)
        .sort((a, b) => Number(a) - Number(b))
        .map((r) => {
          const { in: inP, out: outP } = byRound[r];
          return {
            ...EMPTY_PERIOD(),
            in_date: inP ? (inP.in_date || inP.work_date || inP.clock_date || inP.attendance_date || "") : "",
            out_date: outP ? (outP.out_date || outP.work_date || outP.clock_date || outP.attendance_date || "") : "",
            clock_in: inP ? inP.work_time : "",
            clock_out: outP ? outP.work_time : "",
            break_time: this.normalizeBreakSlot(inP && inP.break_time ? inP.break_time : null),
            in_start: inP ? inP.punch_start_time : "",
            in_end: inP ? inP.punch_end_time : "",
            out_start: outP ? outP.punch_start_time : "",
            out_end: outP ? outP.punch_end_time : "",
            punch_start_time: inP ? inP.punch_start_time : "",
            punch_end_time: inP ? inP.punch_end_time : "",
          };
        });
    },
    emitChange() {
      this.innerPeriods.forEach((p) => this.sanitizeBreakPair(p));
      this.$emit("input", this.clonePeriods(this.innerPeriods));
      this.$emit("change", this.clonePeriods(this.innerPeriods));
    },
    addPeriod() {
      this.innerPeriods.push(EMPTY_PERIOD());
      this.emitChange();
    },
    removePeriod(index) {
      this.innerPeriods.splice(index, 1);
      this.emitChange();
    },
    timeToRangeStr(t) {
      if (!t) return null;
      const s = String(t).trim();
      return s.length === 5 && s.indexOf(":") === 2 ? `${s}:00` : s;
    },
    timeToMinutes(t) {
      if (!t) return null;
      const parts = String(t).trim().split(":");
      const h = parseInt(parts[0], 10);
      const m = parseInt(parts[1], 10);
      if (Number.isNaN(h)) return null;
      return h * 60 + (Number.isNaN(m) ? 0 : m);
    },
    minutesToHHmm(totalMin) {
      const h = Math.floor(totalMin / 60) % 24;
      const m = totalMin % 60;
      return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
    },
    /**
     * 工作时段变更或提交前：把休息裁到 [clock_in, clock_out]；不在这里用 selectableRange（易致面板选项全灰、无法点选）
     */
    sanitizeBreakPair(period) {
      if (!Array.isArray(period.break_time)) {
        this.$set(period, "break_time", ["", ""]);
        return;
      }
      const lo = this.timeToMinutes(period.clock_in);
      const hi = this.timeToMinutes(period.clock_out);
      // 工作时间未填齐时不处理休息，避免用户先选休息后被立即清空
      if (lo == null || hi == null || hi <= lo) return;
      let a = period.break_time[0] ? this.timeToMinutes(period.break_time[0]) : null;
      let b = period.break_time[1] ? this.timeToMinutes(period.break_time[1]) : null;
      if (a == null && b == null) return;
      if (a != null) a = Math.max(lo, Math.min(a, hi));
      if (b != null) b = Math.max(lo, Math.min(b, hi));
      if (a != null && b == null) {
        period.break_time.splice(0, 2, this.minutesToHHmm(a), "");
        return;
      }
      if (a == null && b != null) {
        period.break_time.splice(0, 2, "", this.minutesToHHmm(b));
        return;
      }
      if (a > b) [a, b] = [b, a];
      if (a >= b) {
        period.break_time.splice(0, 2, "", "");
        return;
      }
      period.break_time.splice(0, 2, this.minutesToHHmm(a), this.minutesToHHmm(b));
    },
    addHoursToTime(t, hours) {
      if (!t) return null;
      const [h, m] = String(t).split(":").map(Number);
      if (Number.isNaN(h)) return null;
      const totalMin =
        (h || 0) * 60 + (Number.isNaN(m) ? 0 : m) + hours * 60;
      const h2 = Math.floor(totalMin / 60) % 24;
      const m2 = totalMin % 60;
      return `${String(h2).padStart(2, "0")}:${String(m2).padStart(2, "0")}`;
    },
    getInStartPickerOptions(period) {
      const end = this.timeToRangeStr(period.clock_in);
      if (!end) return {};
      return { selectableRange: `00:00:00 - ${end}` };
    },
    getInEndPickerOptions(period) {
      const start = this.timeToRangeStr(period.clock_in);
      const end = this.timeToRangeStr(this.addHoursToTime(period.clock_in, 1));
      if (!start || !end) return {};
      return { selectableRange: `${start} - ${end}` };
    },
    getOutStartPickerOptions(period) {
      const start = this.timeToRangeStr(period.clock_out);
      if (!start) return {};
      return { selectableRange: `${start} - 23:59:59` };
    },
    getOutEndPickerOptions(period) {
      const start = this.timeToRangeStr(period.clock_out);
      const endRaw = this.addHoursToTime(period.clock_out, 2);
      if (!start || !endRaw) return {};
      const toM = (str) => {
        const [a, b] = String(str).split(":").map(Number);
        return (a || 0) * 60 + (Number.isNaN(b) ? 0 : b);
      };
      const endM = toM(endRaw);
      const startM = toM(period.clock_out);
      const end = endM <= startM ? "23:59:59" : this.timeToRangeStr(endRaw);
      return { selectableRange: `${start} - ${end}` };
    },
    spanMethod({ row, columnIndex }) {
      const colsToMerge = this.isEditMode ? [0, 3, 6] : [0, 3];
      if (!colsToMerge.includes(columnIndex)) return [1, 1];
      if (row.rowType === "out") return [0, 0];
      return [2, 1];
    },
    formatBreakTime(breakTime) {
      if (!breakTime) return "-";
      if (Array.isArray(breakTime) && breakTime.length === 2) {
        if (!breakTime[0] && !breakTime[1]) return "-";
        return breakTime.join("-");
      }
      if (typeof breakTime === "string") {
        return breakTime;
      }
      if (breakTime.start && breakTime.end) {
        return `${breakTime.start}-${breakTime.end}`;
      }
      return "-";
    },
    calcWorkHours(period) {
      if (!period.clock_in || !period.clock_out) return "-";
      const toMin = (t) => {
        const [h, m] = String(t)
          .split(":")
          .map(Number);
        return (h || 0) * 60 + (m || 0);
      };
      let minutes = toMin(period.clock_out) - toMin(period.clock_in);
      if (
        Array.isArray(period.break_time) &&
        period.break_time.length === 2 &&
        period.break_time[0] &&
        period.break_time[1]
      ) {
        minutes -= toMin(period.break_time[1]) - toMin(period.break_time[0]);
      }
      if (
        typeof period.break_time === "string" &&
        period.break_time.includes("-")
      ) {
        const [start, end] = period.break_time.split("-");
        minutes -= toMin(end) - toMin(start);
      }
      if (minutes <= 0) return "0";
      return (minutes / 60).toFixed(1).replace(/\.0$/, "");
    },
  },
};
</script>

<style lang="scss" scoped>
.shift-period-view-table {
  .empty-text {
    color: #909399;
  }
  .break-time-pickers {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: nowrap;
    gap: 4px;
  }
  .break-tp {
    width: 92px;
    max-width: 92px;
  }
  .break-sep {
    color: #909399;
    flex-shrink: 0;
    font-size: 12px;
  }
}
</style>
